var React = require('react');

function SynonymHighlight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round"},React.createElement("g",{"id":"icon13","transform":"translate(4.000000, 4.000000)","stroke":"#333333"},[React.createElement("rect",{"id":"Rectangle-192","transform":"translate(9.840990, 6.409010) rotate(45.000000) translate(-9.840990, -6.409010) ","x":"7.59099026","y":"-0.340990258","width":"4.5","height":"13.5","key":0}),React.createElement("polygon",{"id":"Rectangle-192","transform":"translate(2.840633, 13.409367) rotate(45.000000) translate(-2.840633, -13.409367) ","points":"1.49063312 12.0593669 4.19063312 12.0593669 4.19063312 14.7593669 1.49063312 14.7593669","key":1})])));
}

SynonymHighlight.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = SynonymHighlight;

SynonymHighlight.default = SynonymHighlight;
